import { style, globalStyle } from '@vanilla-extract/css';
import { vars } from '@/shared/ui/theme';
import { reducedMotion } from '@/shared/ui/theme';

// MarkdownEditor footerSlot 전용 — 테두리 있는 editorWrapper 안에 들어가므로
// 자체 border/radius/opacity 를 두면 카드 속 카드가 되고(6px 라운드가 사각 내부
// 코너와 부딪힘) opacity 0.7 이 이 밴드만 흐리게 만든다. 상단 hairline 만 남긴다.
export const container = style({
  display: 'flex',
  flexDirection: 'column',
  gap: '8px',
  padding: '10px 16px',
  backgroundColor: vars.opacityScale.blackOverlay.light,
  borderTop: `1px solid ${vars.surface.liquidGlass.innerSurface.border}`,
  flexShrink: 0,
});

export const title = style({
  fontSize: vars.typography.fontSize['2xs'],
  fontWeight: vars.typography.fontWeight.semibold,
  color: vars.typography.textColor.tertiary,
});

export const fileList = style({
  display: 'flex',
  flexWrap: 'wrap',
  gap: vars.spacing.gap.sm,
});

export const fileItem = style({
  position: 'relative',
  display: 'flex',
  alignItems: 'center',
  gap: vars.spacing.gap.sm,
  padding: '4px 12px',
  backgroundColor: vars.surface.highlight.faint,
  border: `1px solid ${vars.surface.liquidGlass.innerSurface.border}`,
  borderRadius: vars.spacing.borderRadius.xl,
  fontSize: vars.typography.fontSize['2xs'],
  transition: `border-color ${vars.animation.duration.fast} ${vars.animation.easing.easeOut}`,
  selectors: {
    '&:hover': {
      borderColor: vars.bright.primary.default,
    },
  },
  '@media': {
    [reducedMotion]: { transition: 'none' },
  },
});

// PR6: mime icon prepend — Phosphor Icon size 14 duotone
export const fileIcon = style({
  flexShrink: 0,
  color: vars.typography.textColor.tertiary,
});

export const fileName = style({
  color: vars.typography.textColor.secondary,
  maxWidth: '160px',
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  whiteSpace: 'nowrap',
});

export const fileSize = style({
  color: vars.typography.textColor.tertiary,
  fontFamily: vars.typography.fontFamily.mono,
});

export const removeButton = style({
  position: 'relative',
  background: 'none',
  border: 'none',
  color: vars.typography.textColor.tertiary,
  cursor: 'pointer',
  fontSize: vars.typography.fontSize.sm,
  padding: '4px',
  lineHeight: vars.typography.lineHeight.tight,
  transition: `color ${vars.animation.duration.fast}`,
  selectors: {
    '&:hover': {
      color: vars.bright.status.error,
    },
  },
  '@media': {
    [reducedMotion]: { transition: 'none' },
  },
});

// Touch-target hit area expansion (WCAG 2.5.5)
// Visual ~14px × symbol, hit area extends to 24x24 minimum via ::after overlay
globalStyle(`${removeButton}::after`, {
  content: '""',
  position: 'absolute',
  top: '-6px',
  right: '-6px',
  bottom: '-6px',
  left: '-6px',
});

// 툴바 끝 파일 추가 — MarkdownEditor 툴바 버튼과 같은 36px 상자·톤.
export const attachButton = style({
  position: 'relative',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  width: '36px',
  height: '36px',
  flexShrink: 0,
  padding: 0,
  color: vars.typography.textColor.secondary,
  background: 'none',
  border: '1px solid transparent',
  borderRadius: '4px',
  cursor: 'pointer',
  transition: `color ${vars.animation.duration.fast} ${vars.animation.easing.easeOut}, background ${vars.animation.duration.fast} ${vars.animation.easing.easeOut}`,
  selectors: {
    '&:hover': {
      color: vars.bright.primary.light,
      background: vars.surface.highlight.light,
      borderColor: vars.surface.border.secondary,
    },
  },
});

// Touch-target hit area expansion (WCAG 2.5.5 — 44x44 minimum)
globalStyle(`${attachButton}::after`, {
  content: '""',
  position: 'absolute',
  inset: '-4px',
});

export const hiddenInput = style({
  position: 'absolute',
  width: '1px',
  height: '1px',
  overflow: 'hidden',
  clip: 'rect(0,0,0,0)',
  whiteSpace: 'nowrap',
  border: 0,
  padding: 0,
  margin: '-1px',
});

export const emptyText = style({
  fontSize: vars.typography.fontSize.xs,
  color: vars.typography.textColor.tertiary,
  fontStyle: 'italic',
});
